import React from "react";
import { Link } from "react-router-dom";
import { useSite } from "@/context/SiteContext";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import logo from "@/assets/logo.png";
import pureLogo from "@/assets/pure-logo.png";

const QUICK = [
  { to: "/domestic", label: "Domestic Lawncare" },
  { to: "/commercial", label: "Commercial Mowing" },
  { to: "/line-marking", label: "Line Marking" },
  { to: "/clubs", label: "Clubs & Sports" },
  { to: "/service", label: "Service & Repairs" },
  { to: "/about", label: "About Us" },
  { to: "/contact", label: "Contact" },
];

const DEALERS = ["Mammotion", "Roborock", "Stiga", "CastelGarden", "Belrobotics", "FJDynamics"];

export function Footer() {
  const site = useSite();
  return (
    <footer className="bg-brand-ink text-white/80" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <span className="inline-block bg-white rounded-md p-2">
            <img src={logo} alt="Robotic Lawnmower Experts" className="h-14 w-auto block" />
          </span>
          <p className="mt-4 text-sm leading-relaxed">
            Robotic mowing and line marking, backed by local expertise. Professional installation,
            servicing and support across Ireland.
          </p>
          <a href={`tel:${site.phone?.replace(/\s/g, "")}`} className="mt-4 inline-flex items-center gap-2 font-semibold text-white">
            <Phone className="h-4 w-4" /> {site.phone}
          </a>
          <div className="mt-6">
            <p className="text-xs uppercase tracking-widest text-white/50">Finance available through</p>
            <span className="mt-2 inline-block bg-white rounded-md px-3 py-2">
              <img src={pureLogo} alt="Pure Business Finance" className="h-8 w-auto block" data-testid="footer-pure-logo" />
            </span>
          </div>
        </div>

        <div>
          <h4 className="font-display font-semibold text-white text-sm uppercase tracking-widest">Quick Links</h4>
          <ul className="mt-4 space-y-2 text-sm">
            {QUICK.map((q) => (
              <li key={q.to}>
                <Link to={q.to} className="hover:text-white transition-colors">{q.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display font-semibold text-white text-sm uppercase tracking-widest">Find Us</h4>
          <ul className="mt-4 space-y-3 text-sm">
            <li className="flex gap-2"><MapPin className="h-4 w-4 mt-0.5 text-white/60 shrink-0" /> {site.address}</li>
            <li className="flex gap-2"><Mail className="h-4 w-4 mt-0.5 text-white/60 shrink-0" /> <a href={`mailto:${site.email}`} className="hover:text-white break-all">{site.email}</a></li>
            <li className="flex gap-2"><Clock className="h-4 w-4 mt-0.5 text-white/60 shrink-0" /> {site.hours}</li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-semibold text-white text-sm uppercase tracking-widest">Authorised Dealer For</h4>
          <ul className="mt-4 flex flex-wrap gap-2">
            {DEALERS.map((d) => (
              <li key={d} className="text-xs px-2.5 py-1 rounded-full bg-white/10 text-white/90">{d}</li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/60">
          <p>© {new Date().getFullYear()} Robotic Lawnmower Experts. All rights reserved.</p>
          <div className="flex gap-4">
            <Link to="/privacy" className="hover:text-white">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white">Terms of Service</Link>
            <Link to="/cookies" data-testid="footer-cookies-link" className="hover:text-white">Cookie Policy</Link>
            <Link to="/admin" className="hover:text-white">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
